module.exports = __webpack_public_path__ + "static/media/thumb_6.9d3e123a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Main/Images/thumb_6.png
// module id = 82
// module chunks = 0